import type { Enums } from "@/integrations/supabase/types";
import { BUILTIN_ACTIVITY_TYPE_KEYS } from "@/lib/activitySettingsSchema";

function isBuiltinActivityTypeKey(key: string): key is (typeof BUILTIN_ACTIVITY_TYPE_KEYS)[number] {
  return (BUILTIN_ACTIVITY_TYPE_KEYS as readonly string[]).includes(key);
}

/**
 * Maps a logical type key (builtin or custom org key) to DB columns `type` + `activity_type_key`.
 */
export function toActivityTypeColumns(activityTypeKey: string): {
  type: Enums<"activity_type">;
  activity_type_key: string;
} {
  if (isBuiltinActivityTypeKey(activityTypeKey)) {
    return {
      type: activityTypeKey as Enums<"activity_type">,
      activity_type_key: activityTypeKey,
    };
  }
  return {
    type: "user_defined",
    activity_type_key: activityTypeKey,
  };
}

/** Display / filter key: prefer activity_type_key when present, else legacy enum string. */
export function resolveActivityTypeKey(row: { activity_type_key?: string | null; type?: string | null }): string {
  if (row.activity_type_key && String(row.activity_type_key).length > 0) {
    return row.activity_type_key;
  }
  return row.type ? String(row.type) : "task";
}
